import { Unit } from '@elderbyte/ngx-starter'

export class ValueFormatSpec {
  constructor(
    public format: CellNumberFormat,
    public unit: Unit
  ) {}
}

export class CellNumberFormat {
  constructor(public maxFractionDigits: number) {}
}
